import readBooleanEnv from './services/readBooleanEnv';

const publicFeatureLogStoreChanges = readBooleanEnv(
  process.env.NEXT_PUBLIC_FEATURE_LOG_STORE_CHANGES
);
export default publicFeatureLogStoreChanges;
